export enum SortingOrder {
  Desc = 'desc',
  Asc = 'asc',
}
